import React, { useState, useEffect } from "react";
import GUIset_nButton from "./gui/GUIset_nButton";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";

const OptimalStrategy = () => {
	useEffect(() => {
		document.title =
			"Optimal Strategy for a Game: Dynamic Programming vs Greedy Algorithm";
	}, []);

	//67,97,35,77,32
	const [guiTxt1, guiTxtChange1] = useState("8,15,3,7");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonList = [
		{ label: "Random Input", color: "#888888" },
		{ label: "Analyze", color: "#000000" },
	];
	const buttonClick1 = (i) => {
		if(i == 0) buttonRandomInput();
		else process();
	};

	var arr = [];
	var txt_time = "";
	var txt_result = "";
	var memory = []; // int[][]
	var n;
	//
	var simulate_algo = [[1,1],[0,0],[1,0],[0,1]];//1 DP, 0 Greedy
	var txt_simulate_score = [];//[2][4]
	var txt_simulate_title = [];//[4]
	var txt_simulate_detail = [];//[4]
	var score1 = 0;
	var score2 = 0;

	function buttonRandomInput() {
		var txt = "";
		var l = T.rand(11);
		if (l % 1 == 1) l++;//even is better
		for (var i = 0; i < 4 + l; i++) {
			if(txt != "") txt += ",";
			txt += T.rand(100);
		}
		guiTxtChange1(txt);
	}

	function process() {
		if (guiTxt1 != "") {	
			//initialize
			arr = T.str_toListInt(guiTxt1);
			n = arr.length;
			//clear memory (in last it fail before clear last time) ----		
			txt_simulate_score = [];
			txt_simulate_title = [];
			txt_simulate_detail = [];
			resetMemory(n,n);
			//main process
			Timer.start();
			txt_result = maxValue(arr, 0, n - 1, true);
			txt_time = Timer.stop_print();
			//simulation ----
			for(var i = 0; i < simulate_algo.length; i++){
				// console.log(simulate_algo[i][0] + " vs " + simulate_algo[i][1]);
				simulate(i);
			}
			//build result ----
			BuildResult();
			//clear memory ----
			txt_simulate_score = [];
			txt_simulate_title = [];
			txt_simulate_detail = [];
			memory = [];
		}
	}

	function resetMemory(r,c){
		memory = T.getMatrix(r,c,-9999);
		// console.log("r" + memory.length);
		// console.log("c" + memory[0].length);
	}

	function maxValue(arr, start, end, myTurn) {
		// console.log(memory.length);
		// console.log(memory[start].length);
		// console.log(start + " _ " + end + " _ " + myTurn);
    	if(memory[start][end] > -9999) { return memory[start][end];}
    	var result = 0;
    	if(start == end) { if(myTurn) {result = arr[start]; }}
    	else {
    		var a = maxValue(arr, start + 1, end, !myTurn); 
    		var b = maxValue(arr, start, end - 1, !myTurn);  
    		if(myTurn) { result = Math.max(a + arr[start],b  + arr[end]); }//we try to maximize our value
    		else { result = Math.min(a,b); }//opponent try to minimize our value
    	}
    	memory[start][end] = result;
    	return result;
    }

	//1 DP, 0 Greedy
	function simulate(index) {
		var dp1 = simulate_algo[index][0] == 1 ? true : false;
		var dp2 = simulate_algo[index][1] == 1 ? true : false;
		var txt = "";
		var s = 0;
		var e = arr.length - 1;
		var turn = 1;
		var my_total = 0;
		var opp_total = 0;
		while(s <= e){
			txt != "" ? txt += "\n" : txt = txt;
			var v = 0;
			//check if only 1 item left or more
			if(s == e){ v = arr[s]; s++ }
			else{
				var myTurn = turn %2 == 1 ? true : false;
				//check if dynamic programming
				var DP = false;
				if(myTurn && dp1) DP = true;
				else if(!myTurn && dp2) DP = true;
				//DP when more than 2 choice
				if(DP && (e - s) > 2){
					// console.log("esn " + e + s + n);
					var arr0;
					var n0;
					//choice 1, choose first
					arr0 = T.subarray(arr,s+1, e);
					console.log("ARR0 " + arr0);
					n0 = arr0.length;
					resetMemory(n0, n0);
					var c1 = arr[s] + maxValue(arr0, 0, n0-1, false);
					//choice 2, choose last
					arr0 = T.subarray(arr,s, e-1);
					n0 = arr0.length;
					resetMemory(n0, n0);
					var c2 = arr[e] + maxValue(arr0, 0, n0-1, false);
					//
					if(c1 >= c2){
						v = arr[s];
						s++;
					}
					else{
						v = arr[e];
						e--;
					}
				}
				else{
					if(arr[s] >= arr[e]){ v = arr[s]; s++;}
					else { v = arr[e]; e--;}
				}
			}
			if(turn %2 == 1){
				my_total += v;
				txt += turn + ".....P1 chooses " + v + " (Score: " + my_total + ")";
			}
			else{
				opp_total += v;
				txt += turn + ".....P2 chooses " + v + " (Score: " + opp_total + ")";
			}
			turn++;
		}
		score1 = my_total;
		score2 = opp_total;
		//--------
		var title = "";
		title += dp1 ? "DP" : "Greedy";
		title += " (" + score1 + ") vs ";
		title += dp2 ? "DP" : "Greedy";
		title += " (" + score2 + ")";
		//
		txt_simulate_title[index] = title;
		txt_simulate_detail[index] = txt;
		txt_simulate_score[index] = [score1,score2];
    }

	function BuildResult() {
		var txt = txt_time;
		txt += "\n Expected value: " + txt_result;
		var part0 = Template.simple00("mainset", 1, "Result", txt, 26, 22);
		var parts = [];
		parts.push(part0);
		parts.push(<br key="mainspace"/>);
		for (var i = 0; i < txt_simulate_title.length; i++) {
			var p = Template.simple00("set" + i, 1, txt_simulate_title[i], txt_simulate_detail[i], 22, 22);
			parts.push(<br key={"space" + i}/>);
			parts.push(p);
		}
		partResultChange(
			<div>
				{parts}
			</div>
		);
	}

	return (
		<GUIset_nButton
			title={"Optimal Strategy for a Game"}
			desc={
				"We play a game against an opponent by alternating turns. In each turn, a player selects either the first or last item from the row, removes it from the row permanently, and receives the value of the item. Determine the optimal value if we move first."
			}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Items"}
			txtButton={"Analyze"}
			// buttonList={["Random Input","Calculate"]}
			buttonList={buttonList}
		/>
	);
};

export default OptimalStrategy;
